module.exports = __webpack_public_path__ + "pk.svg?98bf7dd18800a862ad03a7bda9571d04";